/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import Immutable from 'immutable';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewStats from 'marketplace-ui-reviews/records/ReviewStats';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import * as ActionTypes from '../actions/ActionTypes';
import { PAGE_KEY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
const initialState = Immutable.fromJS({
  list: new Immutable.List(),
  stats: new ReviewStats(),
  total: 0,
  filters: new ReviewFilters(),
  reviewSubmitted: false
});

const reviews = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_FETCH_RECEIVED:
      return state.set('list', new Immutable.List(Review.fromArray(payload.reviews, ReviewTypes.APP))).set('total', payload.total);

    case ActionTypes.REVIEWS_STATS_RECEIVED:
      return state.set('stats', new ReviewStats(payload).set('reviewType', ReviewTypes.APP));

    case ActionTypes.REVIEW_HELPFUL_RECEIVED:
      {
        const indexToUpdate = state.get('list').findIndex(review => review.get('id') === payload.reviewId);
        return state.set('list', state.get('list').update(indexToUpdate, review => review.toggleHelpful(payload.reviewId, payload.userId, payload.isHelpful)));
      }

    case ActionTypes.DETAILS_FETCH_RECEIVED:
      return state.set('filters', new ReviewFilters({
        reviewTypes: [ReviewTypes.APP],
        entityId: payload.offeringId
      }));

    case ActionTypes.REVIEW_FILTERS_UPDATED:
      {
        let newFilters = state.get('filters').updateFilters(payload);

        if (!payload.hasOwnProperty(PAGE_KEY)) {
          newFilters = newFilters.updateFilters({
            [PAGE_KEY]: 1
          });
        }

        return state.set('filters', newFilters);
      }

    case ActionTypes.REVIEW_WRITE_RECEIVED:
      return state.set('reviewSubmitted', true);

    case ActionTypes.REVIEW_SUBMITTED_RESET:
      return state.set('reviewSubmitted', false);

    default:
      return state;
  }
};

export default reviews;